// DashboardTutor.jsx
import React, { useEffect, useMemo, useRef, useState } from "react";
import { gql, useApolloClient, useMutation, useQuery } from "@apollo/client";
import { Link } from "react-router-dom";
import "./../styles/DashboardTutor.css";

import CoverImage from "../Logos To be used/Trial number 2.png";
import OttoyoLogo from "../Logos To be used/Ottoyo.png";

// NEW: Category + Subject Modals
import DashboardTutorEdit from "./components in pages/DashboardTutorEdit";

// ---- constants ----
const DEFAULT_FACULTY_ID = "1c4e71de-9018-44d3-929e-042704d86516";
const CLOSED_SUBJECT_IDS2 = new Set([
  "385999b9-532a-4526-8ba4-40c86f47a0f2",
  "94ce3248-7a00-40be-b5f6-8c4f831ad526",
  "d2c5857d-4d6c-4e1d-aaa5-a6a0875cac40",
]);

// ---- GraphQL ----
const FACULTY_CATEGORIES_QUERY = gql`
  query FacultyCategoriesByFaculty($facultyId: ID!) {
    facultyCategoriesByFaculty(facultyId: $facultyId) {
      id
      facultyId
      name
      slug
      position
    }
  }
`;

const SUBJECTS_BY_CATEGORY_QUERY = gql`
  query SubjectsByFacultyCategory($facultyCategoryId: ID!) {
    subjectsByFacultyCategory(facultyCategoryId: $facultyCategoryId) {
      position
      subject {
        id
        title
        slug
        description
        imageUrl
        isPublic
      }
      facultyCategory {
        id
      }
    }
  }
`;

const UPDATE_SUBJECT_CATEGORY_POSITION_MUTATION = gql`
  mutation UpdateSubjectCategoryPosition($input: UpdateSubjectCategoryPositionInput!) {
    updateSubjectCategoryPosition(input: $input) {
      position
      subject {
        id
        title
        slug
        description
        imageUrl
        isPublic
      }
      facultyCategory {
        id
      }
    }
  }
`;

const DELETE_SUBJECT_MUTATION = gql`
  mutation DeleteSubject($id: ID!) {
    deleteSubject(id: $id)
  }
`;

// NEW: update category position (reorder categories)
const UPDATE_FACULTY_CATEGORY_MUTATION = gql`
  mutation UpdateFacultyCategory($input: UpdateFacultyCategoryInput!) {
    updateFacultyCategory(input: $input) {
      id
      facultyId
      name
      slug
      position
    }
  }
`;

const sortByNumber2 = (a, b, key) => {
  const av = typeof a?.[key] === "number" ? a[key] : 0;
  const bv = typeof b?.[key] === "number" ? b[key] : 0;
  return av - bv;
};

const getSubjectDashboardPath2 = (subject) => {
  if (CLOSED_SUBJECT_IDS2.has(subject?.id || "")) {
    return `/subject-closed/${subject.id}`;
  }
  return subject?.slug ? `/subject-tutor/${subject.slug}` : "/dashboard-tutor";
};

const PencilIcon2 = ({ className = "" }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path
      d="M4 20h4l10-10-4-4L4 16v4Z"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinejoin="round"
    />
    <path
      d="m12.5 7.5 4 4"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
    />
  </svg>
);

const TrashIcon2 = ({ className = "" }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path
      d="M5 7h14M9 7V5h6v2m-8 0 1 12h8l1-12"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M10 11v5m4-5v5" stroke="currentColor" strokeWidth="1.8" />
  </svg>
);

const PlusIcon2 = ({ className = "" }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path d="M12 5v14M5 12h14" stroke="currentColor" strokeWidth="2.1" />
  </svg>
);

const ChevronIcon2 = ({ className = "" }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path
      d="m9 6 6 6-6 6"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const VisibilityIcon2 = ({ className = "" }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path
      d="M2.5 12s3.5-5 9.5-5 9.5 5 9.5 5-3.5 5-9.5 5-9.5-5-9.5-5Z"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinejoin="round"
    />
    <circle cx="12" cy="12" r="2.8" stroke="currentColor" strokeWidth="1.8" />
  </svg>
);

const DashboardTutor = () => {
  const client2 = useApolloClient();
  const userName = localStorage.getItem("userName") || "";
  const firstName = userName.trim().split(/\s+/)[0] || "";

  // Delete modal state (global)
  const [deleteModalOpen2, setDeleteModalOpen2] = useState(false);
  const [deleteTarget2, setDeleteTarget2] = useState(null);

  const openDeleteModal2 = (payload) => {
    setDeleteTarget2(payload);
    setDeleteModalOpen2(true);
  };

  const closeDeleteModal2 = () => {
    setDeleteModalOpen2(false);
    setDeleteTarget2(null);
  };

  // Category edit/create modal state
  const [categoryModalOpen2, setCategoryModalOpen2] = useState(false);
  const [categoryModalMode2, setCategoryModalMode2] = useState("create"); // "create" | "edit"
  const [categoryModalTarget2, setCategoryModalTarget2] = useState(null);

  const openCreateCategoryModal2 = () => {
    setCategoryModalMode2("create");
    setCategoryModalTarget2(null);
    setCategoryModalOpen2(true);
  };

  const openEditCategoryModal2 = (category) => {
    setCategoryModalMode2("edit");
    setCategoryModalTarget2(category);
    setCategoryModalOpen2(true);
  };

  const closeCategoryModal2 = () => {
    setCategoryModalOpen2(false);
    setCategoryModalTarget2(null);
  };

  // Faculty categories
  const {
    data: categoriesData,
    loading: categoriesLoading,
    refetch: refetchCategories2,
  } = useQuery(FACULTY_CATEGORIES_QUERY, {
    variables: { facultyId: DEFAULT_FACULTY_ID },
    fetchPolicy: "network-only",
  });

  const sortedCategories2 = useMemo(() => {
    const list = categoriesData?.facultyCategoriesByFaculty || [];
    return [...list].sort((a, b) => sortByNumber2(a, b, "position"));
  }, [categoriesData]);

  const [activeSubjectsCount2, setActiveSubjectsCount2] = useState(0);
  const [activeSubjectsTick2, setActiveSubjectsTick2] = useState(0);

  const refreshActiveSubjectsCount2 = () => {
    setActiveSubjectsTick2((n) => n + 1);
  };

  useEffect(() => {
    let cancelled2 = false;

    const loadActiveSubjectsCount2 = async () => {
      if (!sortedCategories2.length) {
        setActiveSubjectsCount2(0);
        return;
      }

      try {
        const responses2 = await Promise.all(
          sortedCategories2.map((cat2) =>
            client2.query({
              query: SUBJECTS_BY_CATEGORY_QUERY,
              variables: { facultyCategoryId: cat2.id },
              fetchPolicy: "network-only",
            })
          )
        );

        const uniqueIds2 = new Set();
        responses2.forEach((res2) => {
          const relations2 = res2.data?.subjectsByFacultyCategory || [];
          relations2.forEach((rel2) => {
            if (rel2?.subject?.id) uniqueIds2.add(rel2.subject.id);
          });
        });

        if (!cancelled2) setActiveSubjectsCount2(uniqueIds2.size);
      } catch (e) {
        if (!cancelled2) setActiveSubjectsCount2(0);
      }
    };

    loadActiveSubjectsCount2();

    return () => {
      cancelled2 = true;
    };
  }, [client2, sortedCategories2, activeSubjectsTick2]);

  // Local categories for smooth reorder + FLIP animation
  const [localCategories2, setLocalCategories2] = useState([]);
  const categoryRefs2 = useRef(new Map()); // categoryId -> element
  const [updateFacultyCategory2] = useMutation(UPDATE_FACULTY_CATEGORY_MUTATION);

  useEffect(() => {
    setLocalCategories2(sortedCategories2);
  }, [sortedCategories2]);

  const animateCategorySwap2 = (beforeRects2) => {
    requestAnimationFrame(() => {
      const afterRects2 = new Map();
      beforeRects2.forEach((_, id) => {
        const el = categoryRefs2.current.get(id);
        if (!el) return;
        afterRects2.set(id, el.getBoundingClientRect());
      });

      beforeRects2.forEach((beforeRect, id) => {
        const afterRect = afterRects2.get(id);
        const el = categoryRefs2.current.get(id);
        if (!beforeRect || !afterRect || !el) return;

        const dx = beforeRect.left - afterRect.left;
        const dy = beforeRect.top - afterRect.top;
        if (dx === 0 && dy === 0) return;

        el.style.transform = `translate(${dx}px, ${dy}px)`;
        el.style.transition = "transform 0s";
        // eslint-disable-next-line no-unused-expressions
        el.offsetHeight;

        el.style.transition = "transform 220ms ease";
        el.style.transform = "translate(0px, 0px)";

        const cleanup = () => {
          el.style.transition = "";
          el.style.transform = "";
          el.removeEventListener("transitionend", cleanup);
        };
        el.addEventListener("transitionend", cleanup);
      });
    });
  };

  // Swap categories vertically
  const swapCategories2 = async (indexA2, indexB2) => {
    if (indexA2 < 0 || indexB2 < 0) return;
    if (indexA2 >= localCategories2.length || indexB2 >= localCategories2.length)
      return;

    const a2 = localCategories2[indexA2];
    const b2 = localCategories2[indexB2];
    if (!a2?.id || !b2?.id) return;

    const beforeRects2 = new Map();
    [a2.id, b2.id].forEach((id) => {
      const el = categoryRefs2.current.get(id);
      if (el) beforeRects2.set(id, el.getBoundingClientRect());
    });

    const next2 = [...localCategories2];
    next2[indexA2] = b2;
    next2[indexB2] = a2;
    setLocalCategories2(next2);

    animateCategorySwap2(beforeRects2);

    const posA2 = a2.position;
    const posB2 = b2.position;

    try {
      await updateFacultyCategory2({
        variables: { input: { id: a2.id, position: posB2 } },
      });
      await updateFacultyCategory2({
        variables: { input: { id: b2.id, position: posA2 } },
      });

      setLocalCategories2((prev) => {
        const copy = [...prev];
        copy[indexA2] = { ...b2, position: posA2 };
        copy[indexB2] = { ...a2, position: posB2 };
        return copy.sort((x, y) => sortByNumber2(x, y, "position"));
      });
    } catch (e) {
      setLocalCategories2(sortedCategories2);
    }
  };

  // --- Category Row ---
  const CategoryRow2 = ({ category, onSubjectsChanged2 }) => {
    const scrollerRef2 = useRef(null);
    const [canScrollLeft2, setCanScrollLeft2] = useState(false);
    const [canScrollRight2, setCanScrollRight2] = useState(false);

    // Subject edit/create modal state (LOCAL per category, so refetch is easy)
    const [subjectModalOpen2, setSubjectModalOpen2] = useState(false);
    const [subjectModalMode2, setSubjectModalMode2] = useState("create"); // "create" | "edit"
    const [subjectModalTarget2, setSubjectModalTarget2] = useState(null); // subject object
    const [subjectModalCategoryId2, setSubjectModalCategoryId2] = useState(
      category.id
    );

    const openCreateSubjectModal2 = () => {
      setSubjectModalMode2("create");
      setSubjectModalTarget2(null);
      setSubjectModalCategoryId2(category.id);
      setSubjectModalOpen2(true);
    };

    const openEditSubjectModal2 = (subject) => {
      setSubjectModalMode2("edit");
      setSubjectModalTarget2(subject);
      setSubjectModalCategoryId2(category.id);
      setSubjectModalOpen2(true);
    };

    const closeSubjectModal2 = () => {
      setSubjectModalOpen2(false);
      setSubjectModalTarget2(null);
    };

    // FLIP refs for swap animation
    const cardRefs2 = useRef(new Map()); // subjectId -> element

    const { data, loading, refetch: refetchSubjects2 } = useQuery(
      SUBJECTS_BY_CATEGORY_QUERY,
      {
        variables: { facultyCategoryId: category.id },
        fetchPolicy: "network-only",
      }
    );

    const [updatePos2] = useMutation(UPDATE_SUBJECT_CATEGORY_POSITION_MUTATION);
    const [deleteSubject2] = useMutation(DELETE_SUBJECT_MUTATION);

    const relationsFromServer2 = useMemo(() => {
      const rel = data?.subjectsByFacultyCategory || [];
      return [...rel].sort((a, b) => sortByNumber2(a, b, "position"));
    }, [data]);

    const [localRelations2, setLocalRelations2] = useState([]);

    useEffect(() => {
      setLocalRelations2(relationsFromServer2);
    }, [relationsFromServer2]);

    const updateScrollButtons2 = () => {
      const el = scrollerRef2.current;
      if (!el) return;
      const left = el.scrollLeft;
      const maxLeft = el.scrollWidth - el.clientWidth;
      setCanScrollLeft2(left > 2);
      setCanScrollRight2(maxLeft - left > 2);
    };

    useEffect(() => {
      updateScrollButtons2();
      const el = scrollerRef2.current;
      if (!el) return;

      const onScroll = () => updateScrollButtons2();
      el.addEventListener("scroll", onScroll);
      window.addEventListener("resize", updateScrollButtons2);

      return () => {
        el.removeEventListener("scroll", onScroll);
        window.removeEventListener("resize", updateScrollButtons2);
      };
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [localRelations2.length]);

    const scrollByCards2 = (dir) => {
      const el = scrollerRef2.current;
      if (!el) return;
      const amount = dir === "left" ? -700 : 700;
      el.scrollBy({ left: amount, behavior: "smooth" });
    };

    const animateSwap2 = (beforeRects2) => {
      requestAnimationFrame(() => {
        const afterRects2 = new Map();
        beforeRects2.forEach((_, id) => {
          const el = cardRefs2.current.get(id);
          if (!el) return;
          afterRects2.set(id, el.getBoundingClientRect());
        });

        beforeRects2.forEach((beforeRect, id) => {
          const afterRect = afterRects2.get(id);
          const el = cardRefs2.current.get(id);
          if (!beforeRect || !afterRect || !el) return;

          const dx = beforeRect.left - afterRect.left;
          const dy = beforeRect.top - afterRect.top;
          if (dx === 0 && dy === 0) return;

          el.style.transform = `translate(${dx}px, ${dy}px)`;
          el.style.transition = "transform 0s";
          // eslint-disable-next-line no-unused-expressions
          el.offsetHeight;

          el.style.transition = "transform 180ms ease";
          el.style.transform = "translate(0px, 0px)";

          const cleanup = () => {
            el.style.transition = "";
            el.style.transform = "";
            el.removeEventListener("transitionend", cleanup);
          };
          el.addEventListener("transitionend", cleanup);
        });
      });
    };

    const swapSubjects2 = async (indexA2, indexB2) => {
      if (indexA2 < 0 || indexB2 < 0) return;
      if (indexA2 >= localRelations2.length || indexB2 >= localRelations2.length)
        return;

      const a2 = localRelations2[indexA2];
      const b2 = localRelations2[indexB2];
      if (!a2?.subject?.id || !b2?.subject?.id) return;

      const beforeRects2 = new Map();
      [a2.subject.id, b2.subject.id].forEach((id) => {
        const el = cardRefs2.current.get(id);
        if (el) beforeRects2.set(id, el.getBoundingClientRect());
      });

      const next2 = [...localRelations2];
      next2[indexA2] = b2;
      next2[indexB2] = a2;
      setLocalRelations2(next2);
      animateSwap2(beforeRects2);

      const posA2 = a2.position;
      const posB2 = b2.position;

      try {
        await updatePos2({
          variables: {
            input: {
              subjectId: a2.subject.id,
              facultyCategoryId: category.id,
              position: posB2,
            },
          },
        });

        await updatePos2({
          variables: {
            input: {
              subjectId: b2.subject.id,
              facultyCategoryId: category.id,
              position: posA2,
            },
          },
        });

        setLocalRelations2((prev) => {
          const copy = [...prev];
          const updatedA = { ...a2, position: posB2 };
          const updatedB = { ...b2, position: posA2 };
          copy[indexA2] = updatedB;
          copy[indexB2] = updatedA;
          return copy;
        });
      } catch (e) {
        setLocalRelations2(relationsFromServer2);
      }
    };

    const requestDelete2 = (rel2) => {
      openDeleteModal2({
        categoryId: category.id,
        subjectId: rel2.subject.id,
        subjectTitle: rel2.subject.title,
        subjectPosition: rel2.position,
        allRelationsSnapshot: localRelations2,
      });
    };

    const confirmDelete2 = async () => {
      if (!deleteTarget2) return;
      if (deleteTarget2.categoryId !== category.id) return;

      const subjectId = deleteTarget2.subjectId;
      const deletedPos = deleteTarget2.subjectPosition;

      const remaining2 = localRelations2
        .filter((r) => r?.subject?.id !== subjectId)
        .map((r) => {
          if (typeof r.position === "number" && r.position > deletedPos) {
            return { ...r, position: r.position - 1 };
          }
          return r;
        })
        .sort((a, b) => sortByNumber2(a, b, "position"));

      setLocalRelations2(remaining2);

      try {
        await deleteSubject2({ variables: { id: subjectId } });

        const toShift2 = (deleteTarget2.allRelationsSnapshot || [])
          .filter((r) => r?.subject?.id !== subjectId)
          .filter((r) => typeof r.position === "number" && r.position > deletedPos);

        for (const r of toShift2) {
          await updatePos2({
            variables: {
              input: {
                subjectId: r.subject.id,
                facultyCategoryId: category.id,
                position: r.position - 1,
              },
            },
          });
        }
      } catch (e) {
        setLocalRelations2(relationsFromServer2);
      } finally {
        if (onSubjectsChanged2) onSubjectsChanged2();
        closeDeleteModal2();
      }
    };

    return (
      <div className="subject-category2">
        <div className="category-header2">
          <div className="category-header-row2">
            <h2 className="category-title2">{`${category.name}`}</h2>

            <button
              className="category-edit-btn2"
              type="button"
              aria-label="Kategorie bearbeiten"
              onClick={() => openEditCategoryModal2(category)}
            >
              <PencilIcon2 className="icon-svg2" />
            </button>
          </div>
        </div>

        <div className="category-row2">
          {canScrollLeft2 && (
            <button
              className="scroll-btn2 scroll-btn-left2"
              onClick={() => scrollByCards2("left")}
              aria-label="Nach links"
              type="button"
            >
              ‹
            </button>
          )}

          <div className="cards-clip2">
            <div className="subject-cards-scroller2" ref={scrollerRef2}>
              <div className="subject-cards2">
                {/* NEW SUBJECT card always first */}
                <div
                  className="subject-card2 subject-card-new2"
                  role="button"
                  aria-label="Neues Fach hinzufügen"
                  tabIndex={0}
                  onClick={openCreateSubjectModal2}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ")
                      openCreateSubjectModal2();
                  }}
                >
                  <div className="new-subject-mark2" aria-hidden="true">
                    <PlusIcon2 className="new-subject-icon2" />
                  </div>
                </div>

                {loading &&
                  Array.from({ length: 3 }).map((_, idx) => (
                    <div className="subject-card2 skeleton2" key={`sk2-${idx}`} />
                  ))}

                {!loading &&
                  localRelations2.map((rel2, idx2) => {
                    const s2 = rel2.subject;
                    const isFirstSubject2 = idx2 === 0;
                    const isLastSubject2 = idx2 === localRelations2.length - 1;
                    const isClosedSubject2 = CLOSED_SUBJECT_IDS2.has(s2?.id || "");

                    return (
                      <div className="subject-card-shell2" key={s2.id}>
                        {!isFirstSubject2 && (
                          <button
                            className="move-btn2 move-btn-left2"
                            type="button"
                            aria-label="Nach links verschieben"
                            onClick={(e) => {
                              e.stopPropagation();
                              swapSubjects2(idx2, idx2 - 1);
                            }}
                          >
                            <ChevronIcon2 className="move-icon-svg2 move-icon-left2" />
                          </button>
                        )}

                        <div
                          className="subject-card2"
                          ref={(el) => {
                            if (el) cardRefs2.current.set(s2.id, el);
                          }}
                        >
                          {s2.imageUrl ? (
                            <img
                              src={s2.imageUrl}
                              alt={s2.title}
                              className="subject-image2"
                              draggable="false"
                            />
                          ) : (
                            <div className="subject-image2 placeholder2">
                              <div className="placeholder-line2" />
                              <div className="placeholder-line2 short2" />
                              <div className="placeholder-line2" />
                            </div>
                          )}

                          <div className="subject-title-dashboard2">{s2.title}</div>

                          {!!s2.description && (
                            <div className="subject-mini-description2">
                              {s2.description}
                            </div>
                          )}

                          <div className="subject-actions2">
                            {/* Keep icon edit: opens modal (old behavior stays) */}
                            <button
                              className="icon-btn2 icon-btn-edit2"
                              type="button"
                              aria-label="Bearbeiten (Icon)"
                              onClick={(e) => {
                                e.stopPropagation();
                                openEditSubjectModal2({
                                  ...s2,
                                  facultyCategoryId2: category.id,
                                });
                              }}
                            >
                              <PencilIcon2 className="icon-svg2" />
                            </button>

                            <button
                              className="icon-btn2 icon-btn-delete2"
                              type="button"
                              aria-label="Löschen"
                              onClick={(e) => {
                                e.stopPropagation();
                                requestDelete2(rel2);
                              }}
                            >
                              <TrashIcon2 className="icon-svg2" />
                            </button>

                            <button
                              className={`icon-btn2 icon-btn-public2 ${
                                s2.isPublic ? "is-public2" : "is-private2"
                              }`}
                              type="button"
                              aria-label="Public"
                              onClick={(e) => e.stopPropagation()}
                            >
                              <VisibilityIcon2 className="status-icon-svg2" />
                            </button>
                          </div>

                          {/* Bottom action opens the subject or the temporary closure notice. */}
                          <Link
                            className="edit-button2"
                            to={getSubjectDashboardPath2(s2)}
                          >
                            {isClosedSubject2 ? "Hinweis" : "Bearbeiten"}
                          </Link>
                        </div>

                        {!isLastSubject2 && (
                          <button
                            className="move-btn2 move-btn-right2"
                            type="button"
                            aria-label="Nach rechts verschieben"
                            onClick={(e) => {
                              e.stopPropagation();
                              swapSubjects2(idx2, idx2 + 1);
                            }}
                          >
                            <ChevronIcon2 className="move-icon-svg2 move-icon-right2" />
                          </button>
                        )}

                        {/* Delete Modal */}
                        {deleteModalOpen2 &&
                          deleteTarget2?.categoryId === category.id &&
                          deleteTarget2?.subjectId === s2.id && (
                            <>
                              <div
                                className="modal-backdrop2"
                                onClick={closeDeleteModal2}
                              />
                              <div className="modal2" role="dialog" aria-modal="true">
                                <div className="modal-title2">Fach löschen</div>
                                <div className="modal-text2">
                                  Möchtest du <strong>{deleteTarget2.subjectTitle}</strong>{" "}
                                  wirklich löschen?
                                </div>

                                <div className="modal-actions2">
                                  <button
                                    className="modal-btn2 modal-btn-cancel2"
                                    type="button"
                                    onClick={closeDeleteModal2}
                                  >
                                    Nein
                                  </button>
                                  <button
                                    className="modal-btn2 modal-btn-confirm2"
                                    type="button"
                                    onClick={confirmDelete2}
                                  >
                                    Ja
                                  </button>
                                </div>
                              </div>
                            </>
                          )}
                      </div>
                    );
                  })}
              </div>
            </div>
          </div>

          {canScrollRight2 && (
            <button
              className="scroll-btn2 scroll-btn-right2"
              onClick={() => scrollByCards2("right")}
              aria-label="Nach rechts"
              type="button"
            >
              ›
            </button>
          )}
        </div>

        {/* Subject modal (create/edit) */}
        <DashboardTutorEdit
          kind2="subject"
          open2={subjectModalOpen2}
          mode2={subjectModalMode2}
          facultyId2={DEFAULT_FACULTY_ID}
          categories2={localCategories2}
          subject2={subjectModalTarget2}
          initialCategoryId2={subjectModalCategoryId2}
          onClose2={closeSubjectModal2}
          onSaved2={async () => {
            await refetchSubjects2();
            if (onSubjectsChanged2) onSubjectsChanged2();
            closeSubjectModal2();
          }}
        />
      </div>
    );
  };

  return (
    <div className="dashboard2">
      <div className="upper-section2">
        <div className="cover-section2">
          <img src={CoverImage} alt="Cover" className="cover-image2" />
          <div className="cover-text2">
            <h1 className="cover-title2">
              Schön, dass du wieder da bist
              {firstName ? `, ${firstName}` : ""}.
            </h1>
            <p className="cover-subtitle2">
              Schön, dich wieder im Professorenbereich zu sehen. Heute kannst du
              deine Fächer leicht aktualisieren und den Überblick behalten.
            </p>
          </div>
          <img src={OttoyoLogo} alt="Ottoyo" className="cover-ottoyo-logo2" />
        </div>
      </div>

      <div className="lower-section2">
        <div className="faculty-overview2">
          <div className="faculty-overview-info2">
            <h2 className="faculty-overview-title2">Fakultätsübersicht</h2>
            <span className="faculty-overview-meta2">
              {activeSubjectsCount2} aktive Fächer
            </span>
          </div>
          <button
            type="button"
            className="faculty-overview-btn2"
            onClick={openCreateCategoryModal2}
            aria-label="Kategorie hinzufügen"
          >
            Kategorie hinzufügen
          </button>
        </div>

        {categoriesLoading ? (
          <div className="categories-loading2">Loading...</div>
        ) : (
          <div className="categories-stack2">
            {localCategories2.map((cat, idx) => {
              const isLast = idx === localCategories2.length - 1;

              return (
                <React.Fragment key={cat.id}>
                  <div
                    ref={(el) => {
                      if (el) categoryRefs2.current.set(cat.id, el);
                    }}
                  >
                    <CategoryRow2
                      category={cat}
                      onSubjectsChanged2={refreshActiveSubjectsCount2}
                    />
                  </div>

                  {!isLast && (
                    <div className="category-swap-controls2" aria-hidden="false">
                      <button
                        className="category-swap-btn2"
                        type="button"
                        aria-label="Kategorie nach unten verschieben"
                        onClick={() => swapCategories2(idx, idx + 1)}
                      >
                        <ChevronIcon2 className="move-icon-svg2 tutor-icon-move-down2" />
                      </button>

                      <button
                        className="category-swap-btn2"
                        type="button"
                        aria-label="Kategorie nach oben verschieben"
                        onClick={() => swapCategories2(idx + 1, idx)}
                      >
                        <ChevronIcon2 className="move-icon-svg2 tutor-icon-move-up2" />
                      </button>
                    </div>
                  )}
                </React.Fragment>
              );
            })}
          </div>
        )}

        <div className="footer-spacing2" />
      </div>

      {/* Category modal (create/edit) */}
      <DashboardTutorEdit
        kind2="category"
        open2={categoryModalOpen2}
        mode2={categoryModalMode2}
        facultyId2={DEFAULT_FACULTY_ID}
        category2={categoryModalTarget2}
        onClose2={closeCategoryModal2}
        onSaved2={async () => {
          await refetchCategories2();
          closeCategoryModal2();
        }}
      />
    </div>
  );
};

export default DashboardTutor;
